var map = {
	"./add-people.svg": "838f",
	"./alert.svg": "659f",
	"./arrow-bottom.svg": "ae00",
	"./arrow-left.svg": "ac3b",
	"./arrow-right.svg": "cd8c",
	"./arrow-top.svg": "d162",
	"./check.svg": "7bae",
	"./close.svg": "8b1b",
	"./doc.svg": "3f7d",
	"./logo.svg": "5b1c",
	"./plus.svg": "eb38",
	"./print.svg": "671e",
	"./upload.svg": "5a96",
	"./user.svg": "6aed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";